import { Form } from "react-bootstrap"
import { useEffect, useState } from "react"

const ControlInput = (props) => {
  const {
    name,
    feedback,
    validTest,
    setValid,
    isValid,
    setValue,
    blurAll,
    ...inputProps
  } = props

  const [isTouched, setIsTouched] = useState(false)

  const handleOnChange = (e) => {
    setValue(e.target.value)
    setValid(name, validTest(e.target.value))
  }

  const handleOnBlur = (e) => {
    setIsTouched(true)
    setValid(name, validTest(e.target.value))
  }

  useEffect(() => {
    if (blurAll) {
      setIsTouched(true)
    }
  }, [blurAll])

  return (
    <Form.Group className="w-100" controlId={name}>
      <Form.Control
        onBlur={handleOnBlur}
        isInvalid={!isValid && isTouched}
        onChange={handleOnChange}
        {...inputProps}
      />
      <Form.Control.Feedback type="invalid" className="fw-semibold">
        <i>{feedback}</i>
      </Form.Control.Feedback>
    </Form.Group>
  )
}
export default ControlInput